import { render } from "./appView.vue?vue&type=template&id=07bf20c0"
import script from "./appView.vue?vue&type=script&lang=js"
export * from "./appView.vue?vue&type=script&lang=js"

import "./appView.vue?vue&type=style&index=0&id=07bf20c0&lang=scss"

import exportComponent from "/var/home/vodsej/ElA/apps-development/frontendapps/ElaBlockchainAdminConsole/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__